import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {baseStyles, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import constants from "../../constants";
import {ColorSeparator} from "src/styles/Colors";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import ManageActivityCTA1 from "src/js/components/activity/ManageActivityCTA1";
import ManageActivityCTA2 from "src/js/components/activity/ManageActivityCTA2";
import {CampaignPreView} from "src/js/components/activity/ManageActivity";

const useStyles = (theme) => ({
});

class ManageActivityCTA extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      previewData: this.getPreviewData(this.props.previewData),
      reload: false,
    };
    this.moveNextCallbackCTA1 = null;
    this.moveNextCallbackCTA2 = null;
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    this.onPreviewUpdated(this.state.previewData);
  }

  componentWillUnmount() {
  }

  updateState(fields, onDone) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
      if (onDone) {
        onDone();
      }
    });
  }

  onPreviewUpdated = (previewActivity) => {
    this.setState({previewData: this.getPreviewData(previewActivity), reload: !this.state.reload}, () => {
      if (this.refActivityView1) {
        this.refActivityView1.reloadPreview(this.state.previewData, 1);
      }
      if (this.refActivityView2) {
        this.refActivityView2.reloadPreview(this.state.previewData, 2);
      }
    });
  }

  getPreviewData(previewActivity) {
    if (previewActivity) {
      return previewActivity;
    }
    return null;
  }

  showCTA2 = () => {
    const {activityData} = this.props;
    return activityData.type !== constants.activity.types.CHALLENGE
      && activityData.type !== constants.activity.types.SOCIAL_CONTENT;
  }

  onMoveCallbackCTA1 = (callback) => {
    this.moveNextCallbackCTA1 = callback;
  };

  onMoveCallbackCTA2 = (callback) => {
    this.moveNextCallbackCTA2 = callback;
  };

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false, showNewRewardValidationMsg: false});
  }

  getData(excludeError) {
    let data = null;
    if (this.moveNextCallbackCTA1) {
      const cta1Data = this.moveNextCallbackCTA1.getData();
      if (!cta1Data) {
        return false;
      }
      data = cta1Data;
    }
    if (this.moveNextCallbackCTA2) {
      const cta2Data = this.moveNextCallbackCTA2.getData();
      if (!cta2Data) {
        return false;
      }
      data = {...cta2Data};
    }
    return data;
  }

  render() {
    const {activityData, app, classes, user, isXS, history, isMD} = this.props;
    const {
      previewData
    } = this.state;

    const viewSeparator = (
      isXS ?
        <FieldSpace multiplier={1}/>
        :
        <React.Fragment>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', padding: FIELD_SPACE, paddingTop: 0}}>
            <div style={{display: 'flex', flex: 1, width: 1.5, backgroundColor: ColorSeparator}} />
          </div>
        </React.Fragment>
    );

    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={isXS ? classes.viewColumnFullWidthNoCenter : classes.viewRowFullWidthNoCenter}>
          <div className={classes.flexColumnNoCenter}>
            <SectionHeaderView labelId={'activity.tabCTA1Hint'}/>
            <ManageActivityCTA1 activityData={activityData} moveNextCallback={this.onMoveCallbackCTA1} onDataUpdated={this.props.onDataUpdated} hideSection={true} />
            {!isXS ?
              <React.Fragment>
                <FieldSpace multiplier={2}/>
                <CampaignPreView
                  classes={classes}
                  isLTR={app.isLTR}
                  history={history}
                  isMD={isMD}
                  isXS={isXS}
                  activityType={activityData.type}
                  previewActivity={previewData}
                  refActivityView={(ref) => this.refActivityView1 = ref}
                  userId={user.id}
                  userBId={user.bId}
                  userRab7Number={user.rab7Number}
                  userImageUrl={user.imageUrl}
                  noSpacing={true}
                  showCtaNumber={1}
                />
              </React.Fragment>
              : null
            }
          </div>

          {this.showCTA2() ?
            <React.Fragment>
              {viewSeparator}
              <div className={classes.flexColumnNoCenter}>
                <SectionHeaderView labelId={'activity.tabCTA2Hint'}/>
                <div className={classes.formActivity}>
                  <ManageActivityCTA2 activityData={activityData} moveNextCallback={this.onMoveCallbackCTA2} onDataUpdated={this.props.onDataUpdated} hideSection={true} />
                    <React.Fragment>
                      <FieldSpace multiplier={2}/>
                      <CampaignPreView
                        classes={classes}
                        isLTR={app.isLTR}
                        history={history}
                        isMD={isMD}
                        isXS={isXS}
                        activityType={activityData.type}
                        previewActivity={previewData}
                        refActivityView={(ref) => this.refActivityView2 = ref}
                        userId={user.id}
                        userBId={user.bId}
                        userRab7Number={user.rab7Number}
                        userImageUrl={user.imageUrl}
                        noSpacing={!isXS}
                        showCtaNumber={2}
                      />
                    </React.Fragment>
                </div>
              </div>
            </React.Fragment>
            :null
          }
        </div>
      </div>
    );
  }
}

ManageActivityCTA.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityCTA.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.admin.user,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityCTA))
);
